import dayjs from 'dayjs';

export function convertTimeAndDate(time, date) {
    const timeSplit = time.split(' - ');
    const dateSplit = date.split('.');

    if (timeSplit.length > 1) {
        const start = dayjs.utc(
            `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}T${timeSplit[0]}:00`
        );
        const end = dayjs.utc(`${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}T${timeSplit[1]}:00`);
        return {
            date: start.format('YYYY-MM-DD'),
            startDateString: start.format('HH:mm'),
            endDateString: end.format('HH:mm')
        };
    } else {
        const start = dayjs.utc(
            `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}T${timeSplit[0]}:00`
        );
        return {
            date: start.format('YYYY-MM-DD'),
            startDateString: start.format('HH:mm')
        };
    }
}
